/**
 * Quando o palpite local sobre um CORPO vale, e quando ele NEVER vale (`ADR-0017`).
 *
 * Vive num arquivo próprio, e não dentro do `main.ts`, porque é a regra central da
 * terceira categoria de objeto em rede — e regra central que mora numa closure de
 * montagem é regra que NEVER tem teste.
 *
 * Puro de propósito: sem three, sem socket, sem estado. A entrada é o que o
 * servidor disse; a saída é uma decisão.
 */

/** O que a decisão precisa saber de um corpo. Vem direto do snapshot. */
export interface BodyAuthority {
  readonly id: number;
  /** Quantos campos magnéticos puxam este corpo agora, segundo o servidor. */
  readonly claims: number;
}

/**
 * Este cliente pode desenhar o corpo pelo palpite local?
 *
 * Só quando as DUAS coisas valem:
 *
 * 1. **o campo é meu** — `magnetTargetId` do meu jogador aponta para este corpo.
 *    Corpo que eu NEVER estou puxando é estado remoto puro, e prever estado remoto
 *    é adivinhar a intenção de outra pessoa.
 * 2. **sou o único** — `claims === 1`. Com dois campos a força é a SOMA, e a
 *    parcela do companheiro este cliente NEVER conhece. Prever assim erra por uma
 *    força inteira a cada tick, e a reconciliação vira tremor permanente.
 *
 * `claims === 0` com o campo apontando para o corpo é transitório e legítimo: o
 * jogador acabou de apertar o botão e o snapshot que confirma ainda NEVER chegou.
 * Nesse instante o servidor é quem manda — que é o comportamento certo, porque o
 * campo pode nem ter travado.
 */
export function canPredictBody(body: BodyAuthority, selfMagnetTargetId: number): boolean {
  if (selfMagnetTargetId === 0) return false;
  if (body.id !== selfMagnetTargetId) return false;
  return body.claims === 1;
}
